/** Long-form newspaper folio: "Wednesday, 13 May 2026 · Edition 04785" */
export function folio(date: Date = new Date()): string {
  const w = date.toLocaleString("en-GB", { weekday: "long" });
  const d = date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  // edition number derived from days-since-epoch — purely decorative
  const ed = Math.floor(date.getTime() / 86_400_000) - 16_000;
  return `${w}, ${d} · Edition ${String(ed).padStart(5, "0")}`;
}

/** "Wed, 13 May 2026" — short date for cards. */
export function shortDate(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** Format a UTC ISO timestamp as a short readable IST clock label.
 *  Crawler runs at IST 04:00–11:00 so this naturally renders as "4:18am",
 *  "5:30am" etc. Returns null for missing timestamps so cells can show "—". */
export function fmtIST(iso: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso.endsWith("Z") || iso.includes("+") ? iso : iso + "Z");
  if (isNaN(d.getTime())) return null;
  return d.toLocaleTimeString("en-IN", {
    hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata",
  }).replace(" ", "").toLowerCase();   // "4:18am"
}

/** Time-since helper: "3 min ago", "2 h ago", "yesterday". */
export function timeSince(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const sec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} h ago`;
  return `${Math.floor(sec / 86400)} d ago`;
}

/** Roman-numeral up to a few hundred (decorative). */
export function roman(n: number): string {
  const map: Array<[number, string]> = [
    [1000, "M"], [900, "CM"], [500, "D"], [400, "CD"],
    [100, "C"], [90, "XC"], [50, "L"], [40, "XL"],
    [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"],
  ];
  let out = "";
  let v = n;
  for (const [val, sym] of map) {
    while (v >= val) {
      out += sym;
      v -= val;
    }
  }
  return out;
}
